import { api } from '@/services/axios'
export interface IFinance {
  campanhaId: number
  dataCadastro: string
  id: number
  pagamentoId: number
  titulo: number
  usuarioId: number
  valorUnitario: number
  status?: string
  nome?: string
  whatsapp?: string
}
export async function getPaymentByCampaignId(rifaId: number) {
  const response = await api.get<IFinance[]>(
    `Pagamento/ListarPagamentosPorCampanha?campanhaId=${rifaId}`,
  )
  return response.data
}

export async function getPaymentByUsuarioId(userId: number) {
  const response = await api.get(
    `Pagamento/ListarPagamentosPorUsuario?usuarioId=${userId}`,
  )
  return response.data
}

export async function getPaymentByPaymentId(paymentId: number) {
  const response = await api.get(`Pagamento/ObterPagamentoPorId/${paymentId}`)
  return response.data
}

export async function getPaymentByExternalId(externalId: number) {
  const response = await api.get(
    `Pagamento/ObterPagamentoPorExternalID/${externalId}`,
  )
  return response.data
}
